import {Component, ViewChildren, ViewChild, SecurityContext, OnInit, AfterViewInit} from '@angular/core';
import {Http} from '@angular/http';
import {ActivatedRoute} from "@angular/router";
import {DomSanitizer} from '@angular/platform-browser'
import {IframeAutoHeightDirective} from '../../shared/directives/iframe-autoheight.directive';
import {WidgetTypeComponent} from './modals/widget-type.modal.component';
import {environment} from "../../../environments/environment";

class WidgetModel {
	public iframes: any;
	public token: string;

	constructor(private sanitizer: DomSanitizer, public html, public css) {
		this.generate();
	}

	generateId() {
		return (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
	}

	generate() {
		this.token = this.generateId();
		this.html = this.sanitizer.bypassSecurityTrustHtml(
					"<html><head>" +
					"<style> body, html { padding:0;margin:0; } </style>" +
					"<script>var TOKEN="+JSON.stringify(this.token)+";</script>" +
					"<script src=/assets/js/jquery.js></script><script src=/assets/js/widget.js></script></head><body>"+
					"<div id='widgetContent'>" +
						this.html +
						"<style>" + this.css + "</style>" +
					"</div>" +
					"</body></html>"
		);
 	}
};

@Component({
    templateUrl: './editor.component.html',
    styleUrls: [ './editor.component.scss' ]
})
export class EditorComponent implements OnInit, AfterViewInit {
	@ViewChildren(IframeAutoHeightDirective) 
	public iframes;
    
    @ViewChild('widgetTypeModal') 
    public widgetTypeModal: WidgetTypeComponent;
 
	public widgets = [];
	public active = -1;
	public mobile = false;

	public isTextEditing: boolean = true;
	public formatting: any = {};

	public mailingId;
	public lang;
	public isLoaded = false;

	private backendUrl = environment.backendUrl;

	constructor(private sanitizer: DomSanitizer, private http: Http, private route: ActivatedRoute) {
        let self = this;
        window.addEventListener('message', function(e) {
            self.handleWindowMessages(e);
        }, false);		
	}

    ngAfterViewInit() {
        this.route.params.subscribe(params => {
          this.mailingId = params.id;
          this.lang = params.lang;

          this.http.get(environment.backendUrl+'api/mailing/'+ this.mailingId + '/content/'+this.lang)
                 .subscribe(
                  response => {
                    this.isLoaded = true;
                    response.json()['html_' + this.lang].forEach((e) => {
                    	this.addWidgetCallback(e, '');
                    });
                  },
                  error => {
                    // toastr
                  }
                );

        });      
    }

	handleWindowMessages(msg) {
		console.log(msg)
		if(typeof msg == 'object') {
			if(msg.data.type=='iframeHeight') {
				document.getElementById("widget_"+msg.data.token).style.height = msg.data.height+'px'
			}
			else if(msg.data.type=='focusin') {
				this.isTextEditing = true;
				this.formatting = msg.data.formatting;

				var inp: any = document.getElementById('foreColor');
				if(inp) {
					inp.value = this.rgbToHex(this.formatting.foreColor);
				}

				inp = document.getElementById('fontSize'); 
				if(inp) {
					inp.value = this.formatting.fontSize;
				}

			}
			// else if(msg.data.type=='focusout') {
			// 	this.isTextEditing = false;
			// }
		}

	}

	rgbToHex(rgb) {
		var val = rgb.match(/rgb\(([0-9]{1,3}), ([0-9]{1,3}), ([0-9]{1,3})\)/);
		if(val.length != 4) {
			return '';
		}
        var v = val[3] | (val[2] << 8) | (val[1] << 16);
        return '#' + (0x1000000 + v).toString(16).slice(1)
	}

	// poniższy zabieg ma na celu odpalenie funkcji addWidgetCallback w kontekście tego componentu, a nie komponentu modala
    public addWidget: Function;
    ngOnInit() {
        this.addWidget = this.addWidgetCallback.bind(this);
    }

	addWidgetCallback(html, css) { 
		this.widgets.push(new WidgetModel(this.sanitizer, html, css));
	}
	// addwidget

	select(i) {
		if(i == this.active) {
			//this.active = -1;
		}
		else {
			this.active = i;
			this.isTextEditing = false;
		}
	}

	// TODO: przy przenoszniu w góre/dół tresc widgeta sie zmienia
	// trzeba przed zrobieniem swapa wczytac do modelu zawartosc z iframe
	up(i) {
		if(i > 0) {
			let swap = this.widgets[i-1];
			this.widgets[i-1] = this.widgets[i];
			this.widgets[i] = swap;
		}
	}

	down(i) {
		if(i < this.widgets.length -1) {
			let swap = this.widgets[i+1];
			this.widgets[i+1] = this.widgets[i];
			this.widgets[i] = swap;
		}
	}

	remove(i) {
	  if(confirm('sure?')) {
	  	this.widgets.splice(i, 1);		
	  }
	}

	setFormatting(cmd) {
		this.formatting[cmd] = !this.formatting[cmd];
		this.sendMessage(this.widgets[this.active].token, {type: cmd, value: this.formatting[cmd]});
	}

	exec(cmd) {
		this.sendMessage(this.widgets[this.active].token, {type: cmd});
	}

	sendMessage(token, msg) {
		let element : any = document.getElementById("widget_"+token);
		element.contentWindow.postMessage(msg, '*');
	}

	fontSize(event) {
		this.formatting.fontSize = event.target.value;
		this.sendMessage(this.widgets[this.active].token, {type: 'fontSize', value: event.target.value});
	}

	fontColor(event) {
		//this.formatting.foreColor = event.target.value;
		this.sendMessage(this.widgets[this.active].token, {type: 'foreColor', value: event.target.value});
	}

	getHtml() : Array<string> {
		var elements : any = document.getElementsByClassName('widgetInstance');
		var html = [];
		for (var i = 0; i < elements.length; ++i) {
			html.push( elements[i].contentDocument.getElementById('widgetContent').innerHTML );
		}	

		return html;	
	}

	test() {
		var html = this.getHtml().join('');

		this.http.post(this.backendUrl+'api/template/test', { content: html })
           .subscribe(
                data => {
                  console.log(data);
                },
                error => {
                 }
           );
	}

	save() {
		var html = this.getHtml()

		this.http.put(this.backendUrl+'api/mailing/' + this.mailingId + '/content/' + this.lang, { html: html })
           .subscribe(
                data => {
                	alert('ok')
                  console.log(data);
                },
                error => {
                 }
           );
	}

}



// WEBPACK FOOTER //
// /code/frontend/src/app/main/editor/editor.component.ts